import {Maybe, MyNewsItem} from '../../../graphql/generated/types';
import {LOCAL_STORAGE_LAST_MY_NEWS_LIST_KEY} from '../constant';

export function getUpdatedMyNewsItemIdList({
  myNews,
}: {
  myNews?: Maybe<MyNewsItem[]>;
}) {
  if (!myNews || myNews.length === 0) {
    return [];
  }

  const updatedMyNewsIdList: number[] = [];

  const prevMyNewsListStr = window.localStorage.getItem(
    LOCAL_STORAGE_LAST_MY_NEWS_LIST_KEY
  );

  if (prevMyNewsListStr) {
    const prevMyNewsList = JSON.parse(prevMyNewsListStr);
    myNews.forEach(myNewsItem => {
      if (!prevMyNewsList.includes(myNewsItem.newsId)) {
        updatedMyNewsIdList.push(myNewsItem.newsId);
      }
    });
  }

  return updatedMyNewsIdList;
}
